var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c("header-tabs", { attrs: { active: _vm.$route.path } }),
      _vm._v(" "),
      _c("el-row", { staticClass: "filter" }, [
        _c(
          "div",
          {
            staticStyle: {
              width: "80%",
              margin: "0 auto",
              "margin-top": "20px",
              "margin-bottom": "20px"
            }
          },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "demo-ruleForm",
                attrs: {
                  model: _vm.form,
                  "label-width": "200px",
                  "label-width": _vm.formLabelWidth
                }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "是否开启设备分播无异常波次一键打包:" } },
                  [
                    _c("el-switch", {
                      on: { change: _vm.change1 },
                      model: {
                        value: _vm.form.check_one,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "check_one", $$v)
                        },
                        expression: "form.check_one"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "一键打包是否开启录入件数校验:" } },
                  [
                    _c("el-switch", {
                      ref: "co_nv",
                      attrs: { disabled: !_vm.form.check_one },
                      on: { change: _vm.change3 },
                      model: {
                        value: _vm.form.check_one_num_valid,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "check_one_num_valid", $$v)
                        },
                        expression: "form.check_one_num_valid"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "改标波次必须通过波次核查才能校验:" } },
                  [
                    _c("el-switch", {
                      on: { change: _vm.change2 },
                      model: {
                        value: _vm.form.label_must_hecha,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "label_must_hecha", $$v)
                        },
                        expression: "form.label_must_hecha"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "质检和售后波次必须通过波次核查才能校验:" }
                  },
                  [
                    _c("el-switch", {
                      on: { change: _vm.change6 },
                      model: {
                        value: _vm.form.quality_inspection_must_checked,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form,
                            "quality_inspection_must_checked",
                            $$v
                          )
                        },
                        expression: "form.quality_inspection_must_checked"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "必须通过拣货或核查才能校验:" } },
                  [
                    _c("el-switch", {
                      on: { change: _vm.change4 },
                      model: {
                        value: _vm.form.picking_and_hecha,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "picking_and_hecha", $$v)
                        },
                        expression: "form.picking_and_hecha"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "拆分发货剩余商品是否允许自动完成打包:" } },
                  [
                    _c("el-switch", {
                      on: { change: _vm.change5 },
                      model: {
                        value: _vm.form.wp_split_auto_pack_remaining,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form,
                            "wp_split_auto_pack_remaining",
                            $$v
                          )
                        },
                        expression: "form.wp_split_auto_pack_remaining"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("el-row", [_c("wave-check-setting")], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f2cea61a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2cea61a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wavepicking/CheckSetting.vue
// module id = null
// module chunks = 